import { Suspense, useState, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { usePromiseTracker } from "react-promise-tracker";
import { ThreeDots } from "react-loader-spinner";
import ViewUserInfo from "./components/Header/ViewUserInfo";
import ChangePass from "./components/Header/ChangePass";
import Header from "./Header";
import Sidebar from "./Sidebar";
//import Footer from "./Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function Main(props) {
    const navigate = useNavigate();
    const LoadingIndicator = (props) => {
        const { promiseInProgress } = usePromiseTracker();
        return (
            promiseInProgress && (
                <div
                    style={{
                        width: window.$(".content-wrapper .content").width(),
                        height: window.$(".content-wrapper .content").height(),
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "rgba(187,190,180,0.3)",
                        zIndex: 1000,
                        position: "absolute",
                    }}>
                    <ThreeDots color="blue" height="60" width="60" />
                </div>
            )
        );
    };
    ///////get data view info personal
    const users = window.getFromStorage("user-info") !== "null" ? JSON.parse(window.getFromStorage("user-info")) : 0;

    const full_fields = {
        path_avatar: "",
        full_name: "",
        birthday: "",
        gender: 1,
        organize_name: "",
        organize_name_father: "",
        resident: "",
        email: "",
        phone: "",
    };
    const [fields, setField] = useState(full_fields);
    async function fetchViewPersonal() {
        if (window.getFromStorage("uvf") !== "null") {
            setField(JSON.parse(window.getFromStorage("uvf")));
        } else {
            const result = await window.fetchWithAuth("staff/getViewPersonal/" + users.id);
            const results = await result.json();
            if (results.data.length !== 0) {
                let userData = results.data;
                if (userData.path_avatar === null) {
                    userData.path_avatar = userData.gender === 1 ? global.config.url.client + "/dist/img/avatar_boy.jpg" : global.config.url.client + "/dist/img/avatar_girl.jpg";
                } else {
                    userData.path_avatar = global.config.url.base + userData.path_avatar;
                }
                setField(userData);
                window.saveToStorage("uvf", JSON.stringify(userData)); ///luu vao localStorage
            }
        }
    }

    ///out context begin
    const [organizeList, setOrganizeList] = useState([]);
    const [cateList, setCateList] = useState(global.config.cates);
    async function fetchOrganizeList() {
        if (await window.indexDB.isStoreEmpty("tbl_organize", users.id)) {
            const result = await window.fetchWithAuth("user/getOrganizeListIdChild");
            const results = await result.json();
            setOrganizeList(results.data);
            window.indexDB.saveAllStore("tbl_organize", results.data, users.id);
        } else {
            const storedData = await window.indexDB.getAllStore("tbl_organize", users.id); // ❗ Cần await ở đây
            setOrganizeList(storedData);
        }
    }
    ///////////end get don vi/////////
    ///CALL FUNCTION
    useEffect(() => {
        if (users === "null" || users === 0) {
            navigate("/logout");
        } else {
            fetchViewPersonal();
            fetchOrganizeList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {/* <Preloader></Preloader> */}

            <Header avatar={fields.path_avatar}></Header>
            <Sidebar></Sidebar>
            <div className="content-wrapper">
                <section className="content">
                    <LoadingIndicator />
                    <Suspense fallback={""}>
                        <Outlet context={[organizeList, cateList, setCateList]} />
                        {/*context={[organizeList,fields]*/}
                    </Suspense>
                </section>
                <ChangePass toast={toast} />
                <ViewUserInfo fields={fields} />
            </div>
            {/* <Footer></Footer> */}
            <ToastContainer />
        </>
    );
}

export default Main;
